import styled from "styled-components";
import colors from "../../designSystem/colors";

export const ModalTitle = styled.div`
  font-size: 40px;
  margin-bottom: 18px;
  text-align: center;
`;

export const InputRow = styled.div`
  margin-bottom: 14px;
  display: flex;
  justify-content: center;
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid ${colors.UI.BORDER.ACCENT};
  border-radius: 6px;
  font-size: 16px;
`;

export const ActionsRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  > * {
    flex: 1 1 0;
    min-width: 120px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const StyledButton = styled.button<{ $primary?: boolean }>`
  flex: 1 1 0;
  min-width: 120px;
  padding: 14px 0;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  color: ${({ $primary }) => ($primary ? "#fff" : "#222")};
  background: ${({ $primary }) =>
    $primary ? colors.UI.BUTTON.PRIMARY.BACKGROUND : colors.UI.BACKGROUND.LIGHT_GREY};
  transition: background 0.2s;
  &:hover {
    opacity: 0.95;
  }
`;

export const ModalWrapper = styled.div`
  width: 40vw;
  min-width: 300px;
  max-width: 95vw;
  height: 30vh;
  min-height: 200px;
  max-height: 90vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
`;
